module.exports = __webpack_public_path__ + "static/media/export.44d7f715.svg";